import React from "react";
import { Dispatcher, HighlightStore } from "../../flux";
import { Isvg } from "../../components";
import { VstButton } from "vstui";

import Highlights from "./highlights";

import setupPrintNotes from "./print-notes-dialog";
import setupOneNote from "../onenote/one-note";

class NotebookContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      totalHighlights: 0
    };

    this._calculateTotalHighlights = this._calculateTotalHighlights.bind(this);
    this._onPrintClick = this._onPrintClick.bind(this);
    this._openOneNotePanel = this._openOneNotePanel.bind(this);
    this._openReviewMode = this._openReviewMode.bind(this);
  }

  componentDidMount() {
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 2);
    Dispatcher.bind(
      Dispatcher.HIGHLIGHTS_CHANGE,
      this._calculateTotalHighlights
    );
    this._calculateTotalHighlights();
  }

  componentWillUnmount() {
    Dispatcher.unbind(
      Dispatcher.HIGHLIGHTS_CHANGE,
      this._calculateTotalHighlights
    );
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() - 2);
  }

  componentDidUpdate(prevProps, prevState) {
    return prevState.totalHighlights !== this.state.totalHighlights;
  }

  _calculateTotalHighlights() {
    const { highlights, subscribedHighlights } = HighlightStore.getAll(
      this.props.isbn
    );
    this.setState({
      totalHighlights: highlights.length + subscribedHighlights.length
    });
  }

  _onPrintClick() {
    setupPrintNotes(this.props.isbn);
  }

  _openOneNotePanel() {
    setupOneNote(this.props.isbn);
    Fraction.Reporter.gaEvent("/onenote-modal-opened");
  }

  _openReviewMode() {
    Dispatcher.emit("Extension.Launch.review-mode", this.props.isbn);
  }

  renderActions() {
    if (this.state.totalHighlights > 0) {
      return (
        <div className="actions">
          <div className="left">
            {Fraction.Brand.OneNote.visible && (
              <button
                className="noButton launch-one-note-button"
                onClick={this._openOneNotePanel}
              >
                <span className="offScreen">
                  {i18n.t("one-note.one-note-button-text")}
                </span>
                <Isvg src="/img/onenote_button.svg" />
              </button>
            )}
            <button
              id="launch-print-notebook-button"
              className="noButton"
              onClick={this._onPrintClick}
            >
              <span className="offScreen">{i18n.t("print.print")}</span>
              <Isvg src="/img/print.svg" />
            </button>
          </div>

          <div className="right">
            <button
              onClick={this._openReviewMode}
              className="noButton launch-review-mode-button"
            >
              {i18n.t("review-mode.review-mode")}
              <Isvg src="/img/launch.svg" />
            </button>
          </div>
        </div>
      );
    }
  }

  render() {
    return (
      <div className="notebook" id="notebook">
        <Highlights isbn={this.props.isbn} />
        {this.renderActions()}
      </div>
    );
  }
}

const gadgetId = "notebook";
module.exports = {
  class: NotebookContainer,
  metadata: () => {
    return {
      id: gadgetId,
      name: i18n.t(`reader.panels.${gadgetId}`),
      learnMore: false,
      launch: "// TODO",
      toggle: false,
      expanded: false,
      type: "panel",
      enabled: () => Fraction.Brand.Sidebar.Buttons.notebook,
      sidebar: {
        icon: "/img/notebook/notebook.svg",
        action: () => {
          Dispatcher.emit(Dispatcher.TOGGLE_PANEL, gadgetId);
        }
      }
    };
  }
};
